<template>
    <div v-if="dataIsLoaded">
        <ResetPhone/>
    </div>
    <div v-else>
        <LoadingComponent/>
    </div>
</template>

<script>
    import LoadingComponent from '@/components/LoadingComponent.vue';
    import ResetPhone from '@/components/laptop/Authorization/ResetPhone.vue';

    export default {
        name: "ResetPhoneView",
        components: {
            LoadingComponent,
            ResetPhone,
        },
        data() {
            return {
                dataIsLoaded: false,
            }
        },
        methods: {
            async loadData() {
                await this.$store.dispatch("fetchSignOut");
                this.dataIsLoaded = true;
            },
        },
        async mounted() {
            await this.loadData();
        }
    }
</script>